module.exports = __webpack_public_path__ + "static/media/new-default-avatar.fbca0f72.svg";